'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var dateSplit = el.dataset.date.split('-');
  var timeSplit = el.dataset.time.split(':');

  var countDownDate = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0], timeSplit[0], timeSplit[1]).getTime();

  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(distance % (1000 * 60) / 1000);

    // Display the result in the element
    context.getElement('.' + context.className + '_Days').innerHTML = days;
    context.getElement('.' + context.className + '_Hours').innerHTML = hours;
    context.getElement('.' + context.className + '_Minutes').innerHTML = minutes;
    context.getElement('.' + context.className + '_Seconds').innerHTML = seconds;

    // Get fixed bar (on pdp)
    var fixedbar = document.querySelector('.prd-FixedBar_Form');
    // Get detail form (on pdp)
    var detailForm = document.querySelector('.prd-DetailForm');
    // Get card options (on product card)
    var cardOptions = el.parentNode.querySelector('.prd-Card_Options');

    // If the count down is finished, hide the bar
    if (distance < 0) {
      clearInterval(x);
      el.classList.add('prd-Countdown-expired');

      // Check if fixed bar exists (only exists on pdp)
      if (fixedbar != null) {
        fixedbar.classList.remove('prd-FixedBar_Form-countdownActive');
      }
      // Check if detail form exists (only exists on pdp)
      if (detailForm != null) {
        detailForm.classList.remove('prd-DetailForm-countdownActive');
      }
      // Check if fixed bar exists (only exists on product card)
      if (cardOptions != null) {
        cardOptions.classList.remove('prd-Card_Options-countdownActive');
      }
    } else {
      // Check if fixed bar exists (only exists on pdp)
      if (fixedbar != null) {
        fixedbar.classList.add('prd-FixedBar_Form-countdownActive');
      }
      // Check if detail form exists (only exists on pdp)
      if (detailForm != null) {
        detailForm.classList.add('prd-DetailForm-countdownActive');
      }
      // Check if fixed bar exists (only exists on product card)
      if (cardOptions != null) {
        cardOptions.classList.add('prd-Card_Options-countdownActive');
      }
    }
  }, 1000);
}